import axios from "axios";


export const getAllBaseClients = () => {
  return axios
    .get(import.meta.env.VITE_CLIENTSERVICE_API + "/GetClients", {
      headers: { "Content-Type": "application/json" },
    })
    .then((res) => {
      return res.data;
    });
};

export const getCareersClient = () => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/client/getClientForBaseClient"
    )
    .then((res) => res.data);
};
